// extracted by mini-css-extract-plugin
export var askAiIcon = "_m4-j";
export var category = "_m4-9";
export var categoryHeader = "_m4-e";
export var container = "_m4-0";
export var group = "_m4-a";
export var groupItems = "_m4-f";
export var groupSeparator = "_m4-k";
export var loading = "_m4-1";
export var noResults = "_m4-3";
export var placeholder = "_m4-2";
export var resultContent = "_m4-5";
export var resultIcon = "_m4-c";
export var resultItem = "_m4-g";
export var resultMeta = "_m4-8";
export var resultSubtitle = "_m4-7";
export var resultSuffix = "_m4-i";
export var resultTitle = "_m4-6";
export var resultsList = "_m4-4";
export var searchGroup = "_m4-d";
export var selected = "_m4-h";
export var subgroup = "_m4-b";